import { initBugsnagTracking as baseInitBugsnagTracking } from './platform/initBugsnagTracking'
import type { BugsnagClient } from './types/BugsnagClient'

export function initBugsnagTracking(client: BugsnagClient) {
  baseInitBugsnagTracking(client)
}
